module.exports = __webpack_public_path__ + "img/about-m.eae17b95.png";